export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/streamWorker.9c3f4ac3.worker.js");
}
